import type { ColorItem } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import cx from 'classnames'
import type React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import usePrintRender from '../../../hooks/usePrintRender'
import css from './Legend.module.scss'
import { LegendItem } from './LegendItem'

export const Legend: React.FC = () => {
  const dispatch = useDispatch()
  const [showInput, setShowInput] = useState<string | null>(null)

  const { isPrinting, isLegend } = usePrintRender()

  const advanced = useSelector(
    migrationProjectSelector.getProjectLegacyAdvanced
  )

  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )
  const colors = useSelector(migrationProjectSelector.getProjectColors)

  const isTopLegend = useSelector(
    migrationProjectSelector.getProjectLegacyIsTopLegend
  )

  const projectColors = colors.filter((color) => color.showInLegend)

  const handleClick = () => {
    if (isReadOnly) {
      return
    }

    if (advanced) {
      dispatch(artBoardActions.changeMode('color'))
    }
  }

  if (projectColors.length === 0 || (isPrinting && !isLegend)) {
    return null
  }

  return (
    <div
      className={cx(css.wrapper, {
        [css.top]: isTopLegend,
        [css.isReadOnly]: isReadOnly,
      })}
      id="legend"
    >
      {projectColors.map((color: ColorItem, index: number) => (
        <LegendItem
          key={index}
          color={color}
          showInput={showInput}
          advanced={advanced}
          isReadOnly={isReadOnly}
          onClick={handleClick}
          onSetShowInput={setShowInput}
        />
      ))}
    </div>
  )
}
